<template>
    <div style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;display: flex;flex-direction: column;">

        <div id="container" style="width: 100%;height: 500px;"></div>
        <div id="searchBar" style="
        margin-top: 10px;
        width: calc(100% - 20px);
        margin-left: 10px;
        margin-right: 10px;
        display: flex;
        flex-direction: column;
        flex: 1;
        ">
            <div style="display: flex;align-items: center;">
                <el-input id="inputBar" placeholder="搜索地点" v-model="searchInput" @input="getGuihua"></el-input>
                <el-button @click="planRoute" type="success" style="margin-left: 10px;">确认</el-button>
            </div>

            <div style="width: 100%;display: flex;flex-direction: column;overflow: auto;  scrollbar-width: none; -ms-overflow-style: none;"
                :style="{ height: selectHeight + 'px' }">
                <div @click="selectAddress(index)" v-for="item, index in pointArr" :key="index"
                    style="display: flex;border-bottom: solid grey 1px;cursor: pointer;padding: 5px 0;justify-content: space-between;">
                    <div
                        style="display: flex;flex-direction: column;flex: 1;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                        <div style="text-align: left;">{{
                            item.title }}</div>
                        <div style="text-align: left;color: gray;font-size: 15px;">
                            {{ item.address }}
                        </div>
                    </div>
                    <div
                        style="height: 100%;display: flex;justify-content: center;align-items: center;margin:0 10px;width: 30px;">
                        <img v-if="selectedAddress == index" src="../assets/正确.png" style="width: 20px;height: 20px;"
                            alt="">
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import request from "../axios/request";
import { mapState } from "vuex";
export default {
    data() {
        return {
            map: null,
            searchInput: null,
            Amap: null,
            selectedAddress: null,
            pointArr: [],
            selectHeight: null,
            selectAddressInfo: null,
            drivingService: null,
        }
    },
    computed: {

        ...mapState(['addForm']),
    },
    mounted() {

        window.handleRoute = (result) => {
            let script = document.getElementById('jsonp-script1')
            script.remove()
            // 处理返回结果
            document.body.removeChild(script);
        };
        // 定义回调函数
        window.handleJsonp = (res) => {
            this.pointArr = res.data
            let script = document.getElementById('jsonp-script')
            script.remove()
        };
        let inputBar = document.getElementById("inputBar")
        const resizeObserver = new ResizeObserver((entries) => {
            requestAnimationFrame(() => {
                for (const entry of entries) {

                    this.selectHeight = entry.contentRect.height - inputBar.offsetHeight


                }
            });
        });
        resizeObserver.observe(document.getElementById("searchBar"));
        this.initAMap()

    },
    methods: {
        submitSelect() {

            this.$store.state.addForm.location = this.selectAddressInfo.address + this.selectAddressInfo.title
            this.$store.state.addForm.lng = this.selectAddressInfo.location.lng
            this.$store.state.addForm.lat = this.selectAddressInfo.location.lat

            this.$router.go(-1)
        }
        ,
        selectAddress(index) {
            this.selectedAddress = index
            this.selectAddressInfo = this.pointArr[index]
        },
        initMap() {
            let myLatitude = 22.6277225
            let myLongitude = 113.855328
            //定义地图中心点坐标
            let center = new MapKit.LatLng(Number(myLatitude), Number(myLongitude))
            //定义map变量，调用 MapKit.Map() 构造函数创建地图
            this.map = new MapKit.Map(document.getElementById('container'), {
                center: center,//设置地图中心点坐标
                zoom: 17.2,   //设置地图缩放级别

            });
            //创建并初始化MultiMarker
            let markerLayer = new MapKit.MultiMarker({
                map: this.map,  //指定地图容器
                //样式定义
                styles: {
                    //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                    "myStyle": new MapKit.MarkerStyle({
                        "width": 25,  // 点标记样式宽度（像素）
                        "height": 35, // 点标记样式高度（像素）
                        // "src": require('../assets/返回.png'),  //图片路径
                        //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                        "anchor": { x: 16, y: 32 }
                    })
                },
                //点标记数据数组
                geometries: [{
                    "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                    "styleId": 'myStyle',  //指定样式id
                    "position": new MapKit.LatLng(Number(myLatitude), Number(myLongitude)),  //点标记坐标位置
                    "properties": {//自定义属性
                        "title": "marker1"
                    }
                }
                ]
            });

            // 初始化路线规划服务
            this.drivingService = new window.AMap.Driving({ map: this.map.native });


        },
        planRoute() {
            this.drivingService.search([116.403857, 39.915285], [116.803857, 39.915285]);
        },
        async getGuihua() {
            let res = await request({
                url: "/amap/api/driving?fromLat=39.915285&fromLng=116.403857&toLat=39.915285&toLng=116.803857",
                method: "GET"
            })
            if (res.data.status == 200) {
            }
        },
        async getPoint() {
            const res = await request.get('/amap/api/getPoint', { params: { searchInput: this.searchInput } });
            if (res.data.status === 200) this.pointArr = res.data.data.data;
        },
        initAMap() {
            this.initMap()

        }
    }
}
</script>
<style scoped></style>
